export default __webpack_public_path__ + "static/media/superhero.ba378799.jpg";